import { render, staticRenderFns } from "./sideView.vue?vue&type=template&id=2b922d7a"
import script from "./sideView.js?vue&type=script&lang=js&external"
export * from "./sideView.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports